
















import { Component, Vue } from 'vue-property-decorator';
import { Actions, Getters } from '@/store/types';
import { Action, Getter } from 'vuex-class';
import MatomoEvents from '@/matomo/events/MatomoEvents';

@Component
export default class NotificationButton extends Vue {
  @Getter(Getters.Notifications.getUnreadCount)
  public unreadCount: number;

  @Action(Actions.Notifications.fetchUnreadCount)
  private fetchUnreadCount: () => void;

  public mounted() {
    this.fetchUnreadCount();
  }

  public trackNotificationsClicked() {
    MatomoEvents.forNotifications.read.publishWithUnreadCount(this.unreadCount);
  }
}
